// HL7v2 ADT trigger events Lens surfaces on an encounter's `adtMessages` extension.
export const ADT_MESSAGE_TYPE_LABELS: Record<string, string> = {
  A01: 'Admit',
  A02: 'Transfer',
  A03: 'Discharge',
  A04: 'Register',
  A06: 'Change to Inpatient',
  A11: 'Cancel Admit',
  A12: 'Cancel Transfer',
  A13: 'Cancel Discharge',
};

// Title for an ADT row. An unrecognized (or missing) message type falls back to the raw code
// (or the bare `ADT` label), never a generic "Unknown"/"Untitled" placeholder.
export const adtMessageTitle = (messageType: string | undefined): string =>
  messageType ? `ADT · ${ADT_MESSAGE_TYPE_LABELS[messageType] ?? messageType}` : 'ADT';
